import React from 'react';
import PropTypes from 'prop-types';

const SvgComponent = ({ fill, ...props }) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <path
      d="M22.14 9.19l-1.48-.8a2.15 2.15 0 01-1.11-1.58l-.68-4.59c0-1.23-1-2.23-2.23-2.23H7.36a2.247 2.247 0 00-2.23 2.24l-.68 4.59c-.1.67-.51 1.26-1.11 1.58l-1.48.8c-.87.46-1.23 1.53-.81 2.42 0 0 .67 1.52 3.21 2.72l-1.39 9.51.88.15 1.09-4h14.32l1.08 4 .88-.16-1.39-9.51c2.54-1.2 3.21-2.72 3.21-2.72.42-.89.07-1.95-.8-2.42zM18.89 19H5.11l1.08-3.95c1.49.43 3.39.72 5.81.72 2.43 0 4.32-.3 5.82-.73L18.89 19z"
      fill={ fill }
    />
  </svg>
);

SvgComponent.propTypes = {
  fill: PropTypes.string
};

export default SvgComponent;
